import styled from "styled-components";

// The visible heading and intro for a page.
//
// Charts, Watchlist and BTC Explorer had neither - no h1, no h2, no sentence
// saying what the page was. That is bad for a reader arriving cold and it is why
// the prerender step had nothing true to write into the HTML: text a page does
// not show cannot be put in front of a crawler.
//
// The copy comes from src/routeMeta.js, which the prerender step reads too, so
// the served HTML and the rendered page cannot say different things.

const Heading = styled.h1`
  /* An h1 for semantics - no page had one - sized to the h2 it replaces, so
     nothing moves. terminal.css puts h1 at 30px, which would be a jump. */
  font-size: 1.5rem;
  line-height: 1.4em;
  /* the gap under the nav belongs to PageContainer, not to the heading */
  margin-top: 0;
  margin-bottom: 2px;
`;

const Intro = styled.p`
  margin-bottom: 1.2rem;
  max-width: 75ch;
`;

const PageHeading = ({ meta }) => (
  <>
    <Heading>{meta.heading}</Heading>
    <Intro>{meta.intro}</Intro>
  </>
);

export default PageHeading;
